import MasterItemUpahApi from './RegItemUpahApi';

export default MasterItemUpahApi;
